// Student/parent online quizzes and video lectures (native /test/takequiz,
// /test/startquiz, /course/lectures, ...). Globally unique — the school-side
// lecture and test actions use unprefixed names.
export const SP_LEARN_QUIZ_STATE = 'SP_LEARN_QUIZ_STATE'
export const SP_LEARN_QUIZ_START = 'SP_LEARN_QUIZ_START'
export const SP_LEARN_QUIZ_ANSWER = 'SP_LEARN_QUIZ_ANSWER'
export const SP_LEARN_QUIZ_SUBMIT = 'SP_LEARN_QUIZ_SUBMIT'
export const SP_LEARN_QUIZ_TIME_LEFT = 'SP_LEARN_QUIZ_TIME_LEFT'
export const SP_LEARN_QUIZ_RESULT = 'SP_LEARN_QUIZ_RESULT'
export const SP_LEARN_LECTURES = 'SP_LEARN_LECTURES'
export const SP_LEARN_LIVE_NOW_LECTURES = 'SP_LEARN_LIVE_NOW_LECTURES'
export const SP_LEARN_SIDEBAR_LECTURES = 'SP_LEARN_SIDEBAR_LECTURES'
export const SP_LEARN_LECTURE_DETAIL = 'SP_LEARN_LECTURE_DETAIL'
export const SP_LEARN_LECTURE_COMMENTS = 'SP_LEARN_LECTURE_COMMENTS'
export const SP_LEARN_LECTURE_ADD_COMMENT = 'SP_LEARN_LECTURE_ADD_COMMENT'
export const SP_LEARN_LECTURE_ONLINE_USERS = 'SP_LEARN_LECTURE_ONLINE_USERS'
export const SP_LEARN_SUBJECTS = 'SP_LEARN_SUBJECTS'
